import { useNavigate } from "react-router-dom";
import { Headset, Zap, ArrowRight, ShieldCheck } from "lucide-react";

// It's Genie Assist's OWN optional paid concierge — kept visibly separate from
// the free official contacts to protect the site's trust positioning.
// Entry point into the chat-first paid flow: describe the issue in chat, then pay.
export default function SpecialistCTA({ brand }) {
  const navigate = useNavigate();

  function startChat() {
    if (brand?.name) sessionStorage.setItem("genie_specialist_brand", brand.name);
    navigate("/chat");
  }

  return (
    <div className="border-2 border-accent p-6 sm:p-8" data-testid="specialist-cta">
      <div className="flex items-start gap-3">
        <Headset className="mt-0.5 h-6 w-6 shrink-0 text-accent" strokeWidth={1.75} />
        <div className="w-full">
          <p className="font-mono text-[11px] uppercase tracking-widest text-accent">
            Optional paid service from us
          </p>
          <h3 className="mt-2 font-serif text-2xl font-medium text-ink">
            Prefer we handle it for you?
          </h3>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted">
            Start a chat and describe your issue — your first message is free. Then choose a plan and
            an It&apos;s Genie Assist specialist picks up your chat live to help you navigate{" "}
            {brand?.name ? `${brand.name}'s` : "the brand's"} support.{" "}
            <strong className="text-ink">The official numbers and links above are always free.</strong>{" "}
            We never ask for your passwords or account details.
          </p>

          <div className="mt-6 grid gap-px bg-hair sm:grid-cols-2">
            <div className="bg-paper p-5">
              <div className="font-mono text-[11px] uppercase tracking-widest text-muted">Standard session</div>
              <div className="mt-1 font-serif text-3xl text-ink">$29</div>
              <p className="mt-2 text-sm text-muted">A specialist works your issue with you in live chat.</p>
            </div>
            <div className="bg-paper p-5">
              <div className="flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-widest text-accent">
                <Zap className="h-3.5 w-3.5" /> Urgent · priority
              </div>
              <div className="mt-1 font-serif text-3xl text-ink">$79</div>
              <p className="mt-2 text-sm text-muted">Jump the queue — priority response within 15 minutes.</p>
            </div>
          </div>

          <div className="mt-4 flex items-center gap-2 border-2 border-accent px-4 py-3" data-testid="specialist-cta-guarantee">
            <ShieldCheck className="h-5 w-5 shrink-0 text-accent" strokeWidth={1.75} />
            <p className="font-mono text-[11px] uppercase tracking-widest text-ink">
              15-minute response guarantee on Urgent — <span className="text-accent">or it&apos;s free</span>
            </p>
          </div>

          <button
            onClick={startChat}
            data-testid="specialist-cta-button"
            className="mt-6 inline-flex items-center justify-center gap-2 bg-accent px-6 py-3.5 font-mono text-sm uppercase tracking-widest text-paper transition-opacity hover:opacity-90"
          >
            Chat with a specialist <ArrowRight className="h-4 w-4" />
          </button>
          <p className="mt-3 font-mono text-[11px] text-muted">
            Describe your issue first · pay only when you&apos;re ready · secure checkout via Stripe
          </p>
        </div>
      </div>
    </div>
  );
}
